import Allprojects from "./components/allprojects";
import config from "./config";
import Loader from "./components/loader";
import { useState, useEffect } from "react";

export default function Projects() {
	const [isLoaded, setIsLoaded] = useState(false);
	const [items, setItems] = useState([]);

	useEffect(() => {
		window.scrollTo(0, 0);
		const url = `https://api.github.com/users/${config.githubUsername}/repos`;
		fetch(url, {
			headers: {
				Authorization: `${config.githubToken}`,
				"Content-Type": "application/json",
				Accept: "application/vnd.github.mercy-preview+json", // MUST ADD TO INCLUDE TOPICS
			},
		})
			.then((res) => res.json())
			.then(
				(result) => {
					setItems(result);
					setIsLoaded(true);
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
					setIsLoaded(true);
				}
			);
	}, []);
	return isLoaded ? (
		<section className="projects">
			<h2 className="section__title">All Projects</h2>
			<span className="section__subtitle">
				List include only public projects posted on GitHub,
				<br />
				fetched using GitHub Api.
			</span>
			<div className="projects__container container">
				<Allprojects data={items} />
			</div>
		</section>
	) : (
		<Loader />
	);
}
